export enum PrescriptionDuration {
  Permanent = "permanent",
  Temporary = "temporary",
}
